// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__E7mrb","large":"styles_large__3FIOH"};